import { CButton, CSidebar, CSidebarFooter, CSidebarHeader, CSidebarToggler } from '@coreui/react';
import { faXmark } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { RootState } from '../../reducers';
import types from '../../types/actions';
import LocalImagesLoader from '../../utils/localImagesLoader';
import { AppSidebarNav } from './AppSidebarNav';
import navigation from './navigation';

const AppSidebar = () => {
	const dispatch = useDispatch();
	const unfoldable = useSelector((state: RootState) => state.layout.sidebarUnfoldable);
	const sidebarShow = useSelector((state: RootState) => state.layout.sidebarShow);

	return (
		<CSidebar
			className='border-end'
			colorScheme='light'
			onVisibleChange={(visible) =>
				dispatch({
					type: types.SET_LAYOUT_SIDEBAR,
					payload: { sidebarShow: visible },
				})
			}
			position='fixed'
			visible={sidebarShow}
		>
			<CSidebarHeader className='border-bottom' style={{ height: '100px' }}>
				<LocalImagesLoader height={50} image={'erikLogoBig.png'} path={'logo'} width={'auto'} />

				<CButton
					onClick={() =>
						dispatch({
							type: types.SET_LAYOUT_SIDEBAR,
							payload: { sidebarShow: false },
						})
					}
				>
					<FontAwesomeIcon icon={faXmark} size='2xl' />
				</CButton>
			</CSidebarHeader>
			<AppSidebarNav items={navigation} />
			<CSidebarFooter className='border-top d-none d-lg-flex'>
				<CSidebarToggler
					onClick={() =>
						dispatch({
							type: types.SET_LAYOUT_UNFOLDABLE,
							payload: { sidebarUnfoldable: !unfoldable },
						})
					}
				/>
			</CSidebarFooter>
		</CSidebar>
	);
};

export default React.memo(AppSidebar);
